import { render, staticRenderFns } from "./ChangeFeed.vue?vue&type=template&id=75839742&scoped=true&"
import script from "./ChangeFeed.vue?vue&type=script&lang=js&"
export * from "./ChangeFeed.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFeed.vue?vue&type=style&index=0&id=75839742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75839742",
  null
  
)

export default component.exports